module.exports = "<div>\t\r\n\t<app-header-nav></app-header-nav>\r\n\t<div class=\"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body\">\r\n\t\t<app-aside-nav></app-aside-nav>\t\r\n\t\t<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\r\n\t\t\t<div class=\"m-content\">\r\n\t\t\t\t<router-outlet></router-outlet>\t\t\t\r\n\t\t\t</div>\t\t\r\n\t\t</div>\r\n\t</div>\r\n\t<app-footer></app-footer>\t\r\n</div>\r\n\r\n<app-scroll-top></app-scroll-top>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main